<template>
  <div class="flex justify-center items-center">
    <div class="spinner" style="--spinner-color: var(--violet);"></div>
  </div>
</template>
